import {registerReactPartial} from '@github-ui/react-core/register-partial'

import {AppInstallBannerPartial} from './AppInstallBannerPartial'

registerReactPartial('app-install-banner-partial', {
  Component: AppInstallBannerPartial,
})
